<template>
  <el-popover
      v-bind="$attrs"
      v-on="$listeners"
      v-model="proxyValue"
      :trigger="trigger"
      @after-leave="close()"
      @show="show"
      popper-class="no-padding-popover"
  >
    <template slot="reference">
      <slot name="reference"></slot>
    </template>
    <div v-if="customMask"
         class="mask"
         @click="close()"
    ></div>
    <div class="popover-style">
      <div v-if="title" class="popover-msg">
        <label class="popover-font">{{title}}</label>
      </div>
      <slot v-if="showContent"></slot>
    </div>
  </el-popover>
</template>

<script>
  import {isMeaningful} from "@/utils/common";

  export default {
    name: "gj-popover",
    props: {
      title: {
        type: String
      },
      value: {
        default: false
      },
      trigger: {
        type: String,
        default: 'click',
        validator: value => ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1
      },
      lazy: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        proxyValue: false,
        showContent: true,
      }
    },
    created() {
      this.value = this.proxyValue;
      if (this.lazy) {
        // 如果为懒加载内容，首次不加载内容
        this.showContent = false;
      }
    },
    computed: {
      customMask() {
        return this.trigger === 'manual';
      }
    },
    watch: {
      value: {
        handler: function (value, old) {
          if (isMeaningful(value) && value !== old) {
            this.proxyValue = value;
          }
        }
      }
    },
    methods: {
      show() {
        this.showContent = true;
      },
      close() {
        this.proxyValue = false;
        this.$emit('close');
      },
    }
  }
</script>

<style scoped>
  /deep/ .el-popover {
    padding: 0;
  }
  .mask {
    top: 0;
    position: fixed;
    left: 0;
    width: 300vw;
    height: 100vh;
    z-index: -1;
  }
  .popover-style {
    background: #fff;
    border-radius: 2px;
  }
  .popover-msg {
    margin-bottom: 8px;
  }
  .popover-font {
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
</style>
